//CORE
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//COMPONENT
import { CoursePageComponent } from './course-page/course-page.component'
import { AuthGuard } from './guard/auth.guard';
import { HomepageComponent } from './homepage/homepage.component'
import { LoginPageComponent } from './login-page/login-page.component'
import { MenuComponent } from './menu/menu.component';
import { ProfilePageComponent } from './profile-page/profile-page.component'

const routes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: LoginPageComponent },
    { path: 'test-login', component: LoginPageComponent },
    { path: 'homepage', component: HomepageComponent/*, canActivate: [AuthGuard] */},
    { path: 'profile', component: ProfilePageComponent, canActivate: [AuthGuard] },
    { path: 'course', component: CoursePageComponent/*, canActivate: [AuthGuard]*/ },
    { path: 'menu', component: MenuComponent },
    { path: '**', redirectTo: '/homepage' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts